import { render, staticRenderFns } from "./LoadingHeader.vue?vue&type=template&id=727f0c52&"
var script = {}
import style0 from "./LoadingHeader.vue?vue&type=style&index=0&id=727f0c52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports